import { getUserState } from '@carvana/core-auth';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { HookError } from 'components/ErrorBoundary';

import { customAttributesMapper } from 'analytics/customAttributesMapper';
import { AnalyticTrackEventType } from 'analytics/types';
import { COOKIE_KEY } from 'constants/browserCache';
import { ROUTES } from 'routes/constants';
import { getCookieItem } from 'utils/browserCache';
import { isDebugMode } from 'utils/debug';
import { getIsNativeMobileApp } from 'utils/mobile';

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  const idToken = getCookieItem(COOKIE_KEY.CVNA_ID_TOKEN);
  const isLoggedIn = getIsNativeMobileApp() ? Boolean(idToken) : getUserState().isLoggedIn;

  let location;

  // Location may not be available, which is fine
  try {
    location = useLocation();
  } catch (e) {
    // console.error(e);
  }
  if (context === undefined) {
    throw new HookError(`${useAnalytics.name} must be used within a Provider.`);
  }

  const screen = location?.pathname === ROUTES.HOME ? 'home' : location?.pathname.slice(1); // since [0] in url pathname is always '/'

  return {
    trackEvent: ({ analyticEvent, details }: AnalyticTrackEventType) => {
      const attributes = {
        ...customAttributesMapper[analyticEvent]?.(details),
        is_logged_in: isLoggedIn,
        screen,
      };
      if (isDebugMode()) {
        console.log('%c📊 Analytic track event logged:\n', 'color: #15ab3d', {
          analyticEvent,
          attributes,
        });
      }
      context.trackEvent(analyticEvent, attributes);
    },
  };
};
